import { minLength, required } from 'vuelidate/lib/validators'
import { abnValidator, abnMinLength } from '@/components/validators'
import store from '@/store'

const countryCode = () => {
  const company = store.getters['company/company']
  return company.info.countryCode
}

const shouldValidateAbn = () => {
  if (countryCode() === 'AU') {
    return true
  } else {
    return false
  }
}

export default {
  provide: function () {
    return {
      $vv: this.$v
    }
  },
  validations: {
    detailGroup: ['creditDetail.vendorAbn', 'creditDetail.creditNo', 'creditDetail.creditDate'],
    creditDetail: {
      vendorAbn: {
        minLength: minLength(abnMinLength(countryCode())),
        validAbn: (value) => {
          if (shouldValidateAbn()) {
            return abnValidator(value)
          } else {
            return true
          }
        }
      },
      creditDate: {
        required
      },
      creditNo: {
        required
      }
    }
  }
}
